module.exports = __webpack_public_path__ + "img/cover-turkcell-foursquare.3ffba34c.jpg";